import React from "react";
import "./devicebar.scss";
import { toast } from "react-toastify";

import {
  resolvedSensorConfigSelector,
  resolvedDataConfigSelector,
  liveSensorValuesSelector
} from "../../../../selectors";

import { colors } from "../../../../helpers/constants";

import { Icon } from "react-icons-kit";
import { flash } from "react-icons-kit/entypo/";
import { withTranslation } from 'react-i18next';

class DeviceBarItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { sensorsInUpdate: [] };
  }

  componentDidUpdate(prevProps, prevState) {
    let { device, sensorConfig } = this.props;
    let { device: prevDevice } = prevProps;
    let { sensorsInUpdate } = this.state;
    // Check if any of the sensors did update (by comparing the liveSensorValues timestamp)
    // traverse all sensors, compare with last timestamps (device from prevProps), if updated, set state, that kicks of a css anim in render, reset state after anim timelength.
    var _s = sensorsInUpdate;
    var _q;
    for (let sensorid in sensorConfig) {
      if (!device || !prevDevice || !sensorid) {
        return;
      }
      let currentSensorValue = liveSensorValuesSelector(device, sensorid);
      let prevSensorValue = liveSensorValuesSelector(prevDevice, sensorid);
      if (
        !currentSensorValue ||
        !currentSensorValue.hasOwnProperty("date") ||
        !prevSensorValue ||
        !prevSensorValue.hasOwnProperty("date")
      ) {
        return;
      }
      let sensorDidUpdate = currentSensorValue.date !== prevSensorValue.date;
      if (sensorDidUpdate) {
        _s = [..._s, parseInt(sensorid)];
        this.setState({ sensorsInUpdate: _s });
        window.setTimeout(() => {
          _q = this.state.sensorsInUpdate.filter(x => x !== parseInt(sensorid));
          this.setState({ sensorsInUpdate: _q });
        }, 550);
      }
    }
  }

  render() {
    let {
      name = "NoName",
      deviceid,
      onDataPressed,
      sensorConfig,
      onSensorPressed,
      lastContact,
      startDrag,
      drag,
      device,
      setHoveredSensor,
      hoveredSensor,
      t
    } = this.props;

    hoveredSensor =
      hoveredSensor && hoveredSensor.hasOwnProperty("sensorid")
        ? hoveredSensor.sensorid
        : false;

    let { sensorsInUpdate } = this.state;

    let neverSeen = lastContact === "never";

    let lastSeenDisplay = neverSeen ? t('never_seen_label') : lastContact;

    // Dragging
    const onSensorDragStart = (evt, sensorid) => {
      toast.warn("Drag on a widget to connect!");
      let { clientX, clientY } = evt;
      try {
        // Put drag starting point to center of sensor button
        let bbox = evt.target.getBoundingClientRect();
        clientX = bbox.x + bbox.width / 2;
        clientY = bbox.y + bbox.height - 3;
      } catch (error) {}
      let dragSource = {
        type: "sensor",
        sensorid: sensorid,
        deviceid: deviceid
      };
      startDrag(clientX, clientY, dragSource);
    };

    //

    let resolvedDataConfig = resolvedDataConfigSelector(device);

    let deviceName =
      resolvedDataConfig &&
      resolvedDataConfig.name &&
      resolvedDataConfig.name !== ""
        ? resolvedDataConfig.name
        : name;

    let deviceInSensorDrag =
      drag &&
      drag.source &&
      drag.source.type === "sensor" &&
      drag.source.deviceid === deviceid;

    return (
      <div className="devicebar_item" onClick={onDataPressed}>
        {/* <div className="devicebar_item_sortcontrols" onClick={(evt)=>{
          evt.stopPropagation()
        }}>
          <button>left</button>
          <button>right</button>
        </div> */}
        <div className="devicebar_item-top">
          <div className="devicebar_item-lastseen">
            {neverSeen && (
              <div style={{ color: "#fe9200", display: "inline-block" }}>
                <Icon size={16} icon={flash} />
              </div>
            )}
            {lastSeenDisplay}
          </div>

          <span className="devicebar_item-devicename">{deviceName}</span>
        </div>
        <div className="devicebar_item-bottom">
          {Object.keys(sensorConfig).length > 0 ? (
            Object.keys(sensorConfig).map((sensor, idx) => {
              let sensorKey = Object.keys(sensorConfig)[idx];
              let resolvedSensorConfig = resolvedSensorConfigSelector(
                device,
                parseInt(sensorKey)
              );

              let sensorName =
                (resolvedSensorConfig &&
                  resolvedSensorConfig.name &&
                  resolvedSensorConfig.name.value) ||
                "S" + (idx + 1);

              let sensorIsinSensorDrag =
                deviceInSensorDrag &&
                drag.source.sensorid === parseInt(sensorKey);
              // COLORS for sensors
              let sensorColor;
              if (
                resolvedSensorConfig &&
                resolvedSensorConfig.color &&
                resolvedSensorConfig.color.value
              ) {
                sensorColor = resolvedSensorConfig.color.value;
              } else if (resolvedDataConfig && resolvedDataConfig.color) {
                sensorColor = resolvedDataConfig.color;
              } else {
                sensorColor = colors["selected"];
              }
              //
              let sensorIsHovered = hoveredSensor === parseInt(sensorKey);
              //
              let sensorIsInUpdate = sensorsInUpdate.some(
                s => s === parseInt(sensorKey)
              );
              // console.log("Q1",sensorsInUpdate,parseInt(sensorKey), sensorIsInUpdate);

              let cssClass = "devicebar_item-sensor";
              cssClass += sensorIsinSensorDrag ? " dragging" : "";
              cssClass += sensorIsHovered ? " hovered" : "";
              cssClass += sensorIsInUpdate ? " inUpdate" : "";
              let cssStyle = { borderColor: sensorColor, color: sensorColor };
              cssStyle =
                sensorIsHovered || sensorIsinSensorDrag || sensorIsInUpdate
                  ? { ...cssStyle, background: sensorColor, color: "white" }
                  : cssStyle;
              return (
                <div
                  id={sensorKey}
                  className={cssClass}
                  key={idx}
                  style={cssStyle}
                  onClick={evt => {
                    evt.stopPropagation();
                    onSensorPressed(sensorKey);
                  }}
                  draggable="false"
                  onMouseDown={evt => {
                    onSensorDragStart.bind(this)(evt, parseInt(sensorKey));
                  }}
                  onMouseEnter={() => {
                    setHoveredSensor(deviceid, parseInt(sensorKey));
                  }}
                  onMouseLeave={() => {
                    setHoveredSensor(false);
                  }}
                >
                  {sensorName}
                </div>
              );
            })
          ) : (
            <div className="devicebar_item-sensor-warning">No Sensors yet</div>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(DeviceBarItem);
